(function($, undefined) {
	
	'use strict';
	var lexiqueForm;
	var formValidator;
	var popupUtil;
	
	var customLexiqueFormValidate = function() {
		var isValid = true;
		var imgElement = $('.lexique-word-form-image-input-preview .img-container', lexiqueForm);
		if (imgElement.css('background-image') === "none") {
			isValid = false;
			imgElement.addClass('error');
		} else {
			imgElement.removeClass('error');
		}
		return isValid;
	};
	
	var submitLexiqueForm = function() {
		var form = $(this).closest('form');
		form.addClass('processing');
		formValidator.validateForm(form);
		var isValid = customLexiqueFormValidate();
		
		if (!form.hasClass('has-error') && isValid) {
			var id = $('[name=id]', form).length > 0 ? $('[name=id]', form).val() : null;
			var word = $('[name=field2]', form).val();
			var imgPath = $('.image-input-preview .img-container', form).attr('data-preview-item-id');
			var definitionTextarea = $('[name=field4]', form);
			var definition = tinymce.get(definitionTextarea.attr('id')).getContent();
			
			var action = "/action/manageGenData";
			var params = {
				ajax: true,
				field1: 'lexique-word',
				field2: word,
				field3: imgPath,
				field4: definition
			};
			if (id) {
				params.id = id;
			}
			$.ajax({
				url: action,
				method: "post",
				data: params,
				complete: function(response) {
					console.log(response.responseText);
					if (response.responseText.indexOf('success') !== -1) {
						location.reload();
					} else {
						form.removeClass('processing');
					}
				}
			});
		} 
		else {
			form.removeClass('processing');
		}
	};

	var submitLexiqueFormPopup = function() {
		var form = $(this).closest('form');
		form.addClass('processing');
		formValidator.validateForm(form);
		var isValid = customLexiqueFormValidate();
		
		if (!form.hasClass('has-error') && isValid) {
			var id = $('[name=id]', form).length > 0 ? $('[name=id]', form).val() : null;
			var word = $('[name=field2]', form).val();
			var imgPath = $('.image-input-preview .img-container', form).attr('data-preview-item-id');
			var definitionTextarea = $('[name=field4]', form);
			var definition = tinymce.get(definitionTextarea.attr('id')).getContent();
			
			var action = "/action/manageGenData";
			var params = {
				ajax: true,
				field1: 'lexique-word',
				field2: word,
				field3: imgPath,
				field4: definition
			};
			if (id) {
				params.id = id;
			}
			$.ajax({
				url: action,
				method: "post",
				data: params,
				complete: function(response) {
					if (response.responseText.indexOf('success') !== -1) {
						console.log(params);
						$('.lexique-word-select').append('<option value="'+params.field2+'">|*'+params.field2+'*|</option>');
						form.removeClass('processing');
						popupUtil.closePopupById('admin-add-word-to-lexique-popup');
					} else {
						form.removeClass('processing');
					}
				}
			});
		} 
		else {
			form.removeClass('processing');
		}
	};
	
	var removeImageLabel = function() {
		var t = $(this);
		var label = t.attr('data-label');
		var target = t.attr('data-target');
		var elementToUpdate = t.prev(target);
		
		if (elementToUpdate.css('background-image') !== 'none') {
			elementToUpdate.css('background-image', 'none');
			elementToUpdate.removeAttr('data-preview-item-id');
			t.addClass('hide');
			updateLabel(label, '', 'fr');
		}
	};
	
	var addLexiqueWordToTextarea = function(word, textarea) {
		if (word.length > 0 && textarea) {
			if (word.indexOf('|*') === -1) {
				word = "|*" + word + "*|";
			}
			tinymce.get(textarea.attr('id')).execCommand('mceInsertContent', false, word);
		}
	};
	
	var toggleRemoveBtn = function() {
		var t = $(this);
		var removeBtn = t.closest('.image-input-preview').find('.remove-preview-btn');
		if (t.css('background-image')) {
			removeBtn.removeClass('hide');
		} else {
			removeBtn.addClass('hide');
		}
	};
	
	var init = function () {
		popupUtil = Fw.component.models().popup;
		formValidator = Fw.component.models().form;
		lexiqueForm = $('.lexique-word-admin-form');
		
		$('.save-lexique-word-btn', lexiqueForm).on('click', submitLexiqueForm);
		$('.save-lexique-word-popup-btn', lexiqueForm).on('click', submitLexiqueFormPopup);
		$('.remove-preview-btn').on('click', removeImageLabel);
		$('.image-input-preview .img-container').on('file-picker-change', toggleRemoveBtn);
	};
	
	$(window).ready(function () {
		init();
	});
	
	var lexiqueUtils = Fw.component.export('lexiqueUtils', {
		addLexiqueWordToTextarea: addLexiqueWordToTextarea,
	});
	
})(jQuery);
